<template>
    <footer class="app-footer" :class="{ 'dark-mode': isDarkMode, 'login-footer': isLogin }">
        <div class="footer-content">
            <p>&copy; {{ currentYear }} SERVICIOS AL SUPER BETA, S.A. DE C.V.</p>
            <div class="version-info" v-if="showVersionInfo">
                <span @click="emitShowChangelog" class="version-link">v{{ appVersion }}</span>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'AppFooter',
    props: {
        isLogin: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showVersionInfo: true,
            appVersion: process.env.VUE_APP_VERSION || '1.0.0'
        }
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        },
        isDarkMode() {
            return sessionStorage.getItem('darkMode') === 'true';
        }
    },
    methods: {
        emitShowChangelog() {
            this.$emit('show-changelog');
        }
    }
}
</script>

<style scoped>
.app-footer {
    width: auto;
    /* Cambiado de 100% a auto para ajustarse al contenido */
    max-width: 80%;
    /* Limitar el ancho máximo */
    font-family: var(--font-body);
    padding: 8px 20px;
    font-size: 0.8rem;
    text-align: center;
    background-color: var(--background-color);
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    border-left: 1px solid rgba(0, 0, 0, 0.05);
    border-right: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 8px 8px 0 0;
    /* Redondear las esquinas superiores */
    position: fixed;
    bottom: 0;
    left: 55%;
    /* Valor por defecto para App principal */
    /* Centrar horizontalmente */
    transform: translateX(-50%);
    /* Completar el centrado */
    z-index: 95;
    transition: all 0.3s ease;
    opacity: 0.6;
    /* Reducir opacidad por defecto */
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    /* Sombra sutil */
}

.login-footer {
    left: 50%;
    /* Valor específico para la página de login */
}

.app-footer:hover {
    opacity: 1;
}

.dark-mode {
    background-color: rgba(40, 40, 40, 0.3);
    color: #e0e0e0;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    border-left: 1px solid rgba(255, 255, 255, 0.05);
    border-right: 1px solid rgba(255, 255, 255, 0.05);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
}

.dark-mode:hover {
    background-color: rgba(40, 40, 40, 0.9);
}

.footer-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    white-space: nowrap;
    /* Evitar que el texto se rompa */
}

.version-info {
    opacity: 0.7;
    font-size: 0.7rem;
}

.version-link {
    cursor: pointer;
    text-decoration: underline;
    transition: opacity 0.3s ease;
}

.version-link:hover {
    opacity: 1;
}

p {
    margin: 0;
}

@media (max-width: 768px) {
    .app-footer {
        padding: 5px 15px;
        font-size: 0.65rem;
        /* Fuente más pequeña en móvil */
        max-width: 95%;
        /* Mayor ancho máximo en móvil */
    }

    .footer-content {
        flex-direction: column;
        gap: 2px;
    }
}
</style>
